import {BaseService} from './BaseService';
import {PostCodeDAO} from '../DAO/PostCodeDAO';

/**
 * PostCodeService
 *
 */
export class PostCodeService extends BaseService {

	public async getAddress(postCode: string) {

		const dao = new PostCodeDAO(this as BaseService);
		return await dao.getAddress(postCode);

	}

}

